import InsufficientPermissionsPage from "./InsufficientPermissionsPage";

export default InsufficientPermissionsPage;
